import { useEffect } from "react";

const SCRIPT_ID = "structured-data-jsonld";

function StructuredData({ data }) {
  useEffect(() => {
    if (!data) return undefined;

    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);

    return undefined;
  }, [data]);

  return null;
}

export default StructuredData;
